/**
 * i18n Configuration
 * Bilingual support for English and Chinese
 *
 * 国际化配置
 * 支持英文和中文双语
 */

import { createI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'

export const i18n = createI18n({
  legacy: false,
  locale: 'zh', // Default to Chinese
  fallbackLocale: 'en',
  messages: {
    en,
    zh,
  },
})

export default i18n
